class BESSAppProjectBookmarks extends BESSAppBase {

    constructor() {
        super();
        this.bookmarksSidebar = $('.app-sidebar-bookmarks')
    }

    start() {
        this.api = BESSApp.instance.services.api.project;
        let manager = this;
        $('.app-bookmark').each(function () {

            new BESSAppProjectBookmark($(this), manager);

        });
    }

    toggleBookmark(bookmark) {
        this.log('toggleBookmark', this);
        this.api.apiToggleBookmark(
            bookmark.bookmarkType,
            bookmark.bookmarkQualifier,
            this.#updateBookmarks.bind(this)
        )
    }

    #updateBookmarks(result) {
        this.bookmarksSidebar.replaceWith($(result.bookmarks));
        this.bookmarksSidebar = $('.app-sidebar-bookmarks')
        this.bookmarksSidebar.highlight2();
        BESSAppComponent.initialiseFor(this.bookmarksSidebar);
    }
}

class BESSAppProjectBookmark extends BESSAppBase {

    constructor(node, manager) {
        super();
        this.node = node;
        this.bookmarkType = node.data('bookmark-type');
        this.bookmarkQualifier = node.data('bookmark-qualifier');
        this.manager = manager;
        this.bookmarked = this.node.hasClass('app-bookmarked');
        this.node.attr('aria-checked', this.bookmarked);

        this.onSelected(node, this.#onToggle);
    }

    #onToggle() {
        this.bookmarked = !this.bookmarked;
        this.node.addClassIf('app-bookmarked', this.bookmarked);
        this.node.addClassIf('bi-primary', this.bookmarked);
        this.node.addClassIf('bi-secondary', !this.bookmarked);
        this.node.attr('aria-checked', this.bookmarked);
        this.manager.toggleBookmark(this);
    }
}